var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "c-change-log" },
    [
      [
        _c(
          "div",
          {
            staticClass:
              "c-change-log__content t-background-white-grey t-margin-bottom-s"
          },
          [
            _c("h2", { staticClass: "t-text-style-beta c-change-log__title" }, [
              _vm._v("Ändringshistorik")
            ]),
            _vm._v(" "),
            [
              _vm.changeLogEntries.length > 0
                ? _c(
                    "div",
                    {
                      staticClass:
                        "c-change-log__listing t-margin-top-s t-margin-bottom-s"
                    },
                    _vm._l(_vm.changeLogEntries, function(entry) {
                      return _c(
                        "div",
                        {
                          key: entry.date,
                          staticClass:
                            "c-change-log-list__item t-margin-bottom-s"
                        },
                        [
                          _c("span", { staticClass: "c-change-log__info" }, [
                            _vm._v(
                              "Uppdatering - " +
                                _vm._s(_vm.formatDateAndTime(entry.date))
                            )
                          ]),
                          _vm._v(" "),
                          _c("div", {
                            staticClass: "s-text s-text--vue",
                            domProps: { innerHTML: _vm._s(entry.message) }
                          })
                        ]
                      )
                    }),
                    0
                  )
                : _c(
                    "div",
                    { staticClass: "t-margin-top-s t-margin-bottom-s" },
                    [_vm._v("\n          Ändringshistorik saknas.\n        ")]
                  )
            ],
            _vm._v(" "),
            _vm.showCreate
              ? [
                  _c(
                    "form",
                    {
                      staticClass: "c-form c-process-item__form",
                      on: {
                        submit: function($event) {
                          $event.preventDefault()
                          return _vm.handleSubmit($event)
                        }
                      }
                    },
                    [
                      _c(
                        "fieldset",
                        [
                          _c(
                            "div",
                            { staticClass: "c-form__item" },
                            [
                              _c("vue-input", {
                                ref: "description",
                                attrs: {
                                  label: "Beskrivning på ändring",
                                  "input-id": "description",
                                  maxlength: _vm.maxLength,
                                  value: _vm.description,
                                  type: "textarea"
                                },
                                on: {
                                  notifyExceedingMaxlength:
                                    _vm.notifyExceedingMaxlength
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c("can", { attrs: { i: "notify", a: "change" } }, [
                            _c(
                              "div",
                              { staticClass: "c-form__item" },
                              [
                                _c("vue-input", {
                                  ref: "notify",
                                  staticClass: "t-margin-bottom-m",
                                  attrs: {
                                    label: "Informera om ändringarna",
                                    "input-id": "notify",
                                    type: "checkbox"
                                  }
                                })
                              ],
                              1
                            )
                          ]),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "t-margin-top-s t-margin-bottom-s" },
                            [
                              _c(
                                "button",
                                {
                                  staticClass: "c-button c-button--primary",
                                  attrs: {
                                    type: "submit",
                                    disabled: _vm.exceedingMaxlength
                                  },
                                  on: {
                                    click: function($event) {
                                      return _vm.setSubmitType("create")
                                    }
                                  }
                                },
                                [
                                  _vm._v(
                                    "\n                Lägg till\n              "
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "button",
                                {
                                  class: "c-button c-button--linkstyle",
                                  attrs: { type: "submit" },
                                  on: {
                                    click: function($event) {
                                      return _vm.showCreateView()
                                    }
                                  }
                                },
                                [
                                  _vm._v(
                                    "\n                Avbryt\n              "
                                  )
                                ]
                              )
                            ]
                          )
                        ],
                        1
                      )
                    ]
                  )
                ]
              : _vm._e(),
            _vm._v(" "),
            _c("can", { attrs: { i: "manage", a: _vm.processType } }, [
              !_vm.showCreate
                ? _c(
                    "button",
                    {
                      staticClass: "c-button c-button--secondary",
                      attrs: { type: "button" },
                      on: {
                        click: function($event) {
                          return _vm.showCreateView()
                        }
                      }
                    },
                    [_vm._v("\n          Lägg till kommentar\n        ")]
                  )
                : _vm._e()
            ]),
            _vm._v(" "),
            !_vm.showCreate
              ? _c(
                  "button",
                  {
                    class:
                      "c-button " +
                      (this.$can("manage", _vm.processType)
                        ? "c-button--linkstyle"
                        : "c-button--secondary"),
                    attrs: { type: "submit" },
                    on: {
                      click: function($event) {
                        return _vm.toggleChangeLog()
                      }
                    }
                  },
                  [_vm._v("\n        Stäng\n      ")]
                )
              : _vm._e(),
            _vm._v(" "),
            !_vm.showCreate && _vm.unreadNotifications
              ? _c(
                  "button",
                  {
                    class:
                      "c-button " +
                      (this.$can("manage", _vm.processType)
                        ? "c-button--linkstyle"
                        : "c-button--primary"),
                    attrs: { type: "submit" },
                    on: {
                      click: function($event) {
                        return _vm.clickedReadConsent()
                      }
                    }
                  },
                  [_vm._v("\n      Tagit del av uppdatering\n      ")]
                )
              : _vm._e()
          ],
          2
        )
      ]
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }